const PlanStatus = Object.freeze({
  ACTIVE: 'active',
  ACTIVATING: 'activating',
  DEACTIVATED: 'deactivated',
  DELETING: 'deleting'
})

export {
  PlanStatus
}
